const customerResetMutation = /* GraphQL */ `
	mutation customerReset($password: String!, $resetUrl: URL!) {
		customerResetByUrl(password: $password, resetUrl: $resetUrl) {
			customer {
				id
				email
			}
			customerAccessToken {
				accessToken
			}
			customerUserErrors {
				message
				field
				code
			}
		}
	}
`

export default customerResetMutation
